export const DEFAULT_CARGO_TIERS = [
  { maxDesi: 1, price: 50 },
  { maxDesi: 5, price: 80 },
  { maxDesi: 10, price: 120 }
];

const normalizeCargoTier = (tier = {}) => ({
  maxDesi: Math.max(0, Number(tier.maxDesi) || 0),
  price: Math.max(0, Number(tier.price) || 0)
});

export const normalizeCargoPricing = (raw = {}) => {
  const tiersSource = Array.isArray(raw?.tiers) && raw.tiers.length
    ? raw.tiers
    : DEFAULT_CARGO_TIERS;
  const tiers = tiersSource
    .map(normalizeCargoTier)
    .filter((tier) => tier.maxDesi > 0)
    .sort((a, b) => a.maxDesi - b.maxDesi);

  return {
    minFee: Math.max(0, Number(raw?.minFee) || 0),
    extraPerDesi: Math.max(0, Number(raw?.extraPerDesi) || 0),
    freeShippingEnabled: raw?.freeShippingEnabled === true || raw?.freeShippingEnabled === 'true',
    freeShippingMinTotal: Math.max(0, Number(raw?.freeShippingMinTotal) || 0),
    tiers: tiers.length ? tiers : DEFAULT_CARGO_TIERS.map(normalizeCargoTier)
  };
};

export const getFreeShippingProgress = ({ cartTotal = 0, cargoPricing, delivery } = {}) => {
  const source = cargoPricing || delivery?.cargoPricing || {};
  const enabled = source.freeShippingEnabled === true || delivery?.freeShippingEnabled === true;
  const threshold = Math.max(
    0,
    Number(source.freeShippingMinTotal ?? delivery?.freeShippingMinTotal) || 0
  );
  if (!enabled || threshold <= 0) {
    return { enabled: false, threshold: 0, remaining: 0, qualified: false };
  }
  const total = Math.max(0, Number(cartTotal) || 0);
  const remaining = Number(Math.max(0, threshold - total).toFixed(2));
  return {
    enabled: true,
    threshold,
    remaining,
    qualified: remaining <= 0
  };
};

export const calculateCargoFee = ({ totalDesi = 0, cargoPricing, cartTotal } = {}) => {
  const pricing = normalizeCargoPricing(cargoPricing);
  const progress = getFreeShippingProgress({ cartTotal, cargoPricing: pricing });
  if (progress.qualified) {
    return 0;
  }
  const desi = Math.max(0, Number(totalDesi) || 0);
  if (!pricing.tiers.length) {
    return Number(pricing.minFee.toFixed(2));
  }

  const matched = pricing.tiers.find((tier) => desi <= tier.maxDesi);
  let fee;
  if (matched) {
    fee = matched.price || 0;
  } else {
    const last = pricing.tiers[pricing.tiers.length - 1];
    const overageDesi = Math.max(0, desi - last.maxDesi);
    fee = (last.price || 0) + overageDesi * (pricing.extraPerDesi || 0);
  }

  fee = Math.max(pricing.minFee, fee);
  return Number(fee.toFixed(2));
};

export const sumCartDesi = (items = []) => {
  const total = items.reduce((sum, item) => {
    const desi = Math.max(0, Number(item?.product?.desi ?? item?.desi) || 0);
    const qty = Math.max(0, Number(item?.quantity) || 0);
    return sum + desi * qty;
  }, 0);
  return Number(total.toFixed(3));
};
